import { AvailableLanguages } from "@/components/common/language-select/utils/types/types";

export const languageOptions: { title: string; code: AvailableLanguages }[] = [
  {
    title: "English",
    code: "en",
  },
  {
    title: "Portuguese",
    code: "pt",
  },
];

export const languagePreferenceKey = "c8r:language";
